import { Link } from 'react-router-dom';
import { ColorSet } from 'src/theme/colors';
import styled, { css } from 'styled-components';

export const StyledLink = styled(Link)<{ $color?: keyof ColorSet }>`
  cursor: pointer;
  color: inherit;
  text-decoration: underline;
  ${({ theme, $color }) =>
    $color &&
    css`
      color: ${theme.colors[$color]} !important;
    `};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gp1} !important;
    * {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.gp1} !important;
    }
  }
`;
